import { render, staticRenderFns } from "./PenilikanTanam.vue?vue&type=template&id=14922598"
import script from "./PenilikanTanam.vue?vue&type=script&lang=js"
export * from "./PenilikanTanam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports